import { gql } from '../__generated__/index.js';

//language=graphql
export const deleteWish = gql(`
    mutation deleteWish($wishId: ID!) {
        deleteWish(wishId: $wishId)
    }
`);
